import React from "react";
import moment from "moment";
import Datetime from "react-datetime";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog } from "../framework/dialog";
import { Base } from "ui/Scripts/source/framework/base";
import { DialogButtonType } from "ui/Scripts/source/models/enums";

interface ISelectDayDialogProps {
  classes?: string;
  defaultValue: string;
  onOk: (dateStr: string) => void;
  onCancel: () => void;
}

export const SelectDayDialog = (
    props: ISelectDayDialogProps
) => {
    const dialogClasses = "selectDayDialog" + (!Base.isNullOrEmpty(props.classes) ? " " + props.classes : "");
    
    const handleChange = (value: moment.Moment | string) => {
        const newValue = typeof value === "string"
            ? (value ?? "")
            : Base.timeToDateStr(value);
        if (!newValue) return;
        props.onOk(newValue);
    };

    const handleBlur = (value: moment.Moment | string) => {
        if (typeof value === "string" && !value) {
            return;
        }
        props.onOk(Base.timeToDateStr(typeof value === "string"
            ? value.toDate().getTime()
            : value));
    };

    return (
        <Dialog
            classes={dialogClasses}
            title={Translations.SelectDate}
            body={
                <div>
                    <Datetime
                        locale={appConfig.culture}
                        className="roWhite fullWidth"
                        value={props.defaultValue}
                        dateFormat={"D.M.YYYY"}
                        timeFormat={false}
                        closeOnSelect={true}
                        input={false}
                        open={true}
                        inputProps={{ maxLength: 10, readOnly: true, autoFocus: true }}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </div>
            }
            buttons={[{ title: Translations.Cancel, buttonType: DialogButtonType.Default, onClick: props.onCancel }]}
            onClose={props.onCancel}
        />
    );
};